export class AlertModel {
	type: AlertType;
	message: string;
	alertId: string;
	url: string;
	keepAfterRouteChange: boolean;

	constructor(init?: Partial<AlertModel>) {
		Object.assign(this, init);
	}
}

export enum AlertType {
	Success = 'success',
	Error = 'danger',
	Info = 'info',
	Warning = 'warning',
	Primary = 'primary',
	Secondary = 'secondary',
	Light = 'light',
	Dark = 'dark'
}
